/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import ReactPlayer from 'react-player/lazy'

// Elements
import HeroDefault from 'components/elements/HeroDefault'
import OtherService from 'components/elements/OtherService'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import Image from 'components/shared/Image'
import ParseContent from 'components/shared/ParseContent'

// Images
import Img from 'img/back4.png'

const Content = styled(ParseContent)`
  font-family: ${(props) => props.theme.font.family.main};
  font-size: ${(props) => props.theme.font.size.m};
  line-height: ${(props) => props.theme.font.size.xl};
  font-weight: ${(props) => props.theme.font.weight.m};
  color: ${(props) => props.theme.color.text.main};
  
  h2 {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: ${(props) => props.theme.font.size.xxxl};
    font-weight: ${(props) => props.theme.font.weight.m};
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 40px;

    @media screen and (max-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xxl};
    }

    &::before {
      content: "";
      position: absolute;
      background-color: ${props => props.theme.color.face.main};
      height: 5px;
      width: 2000px;
      left: 0;
      bottom: 0;
    }
  }
`

const Player = styled(ReactPlayer)`
  background-color: #101010;
  max-width: 600px;
  margin: 0 auto;
  display: block;
  border-radius: 5px;
  overflow: hidden;
`

const PageTemplate = ({
  data: {
    page: { path, wordpress_id, yoast_meta: yoast, acf },
  },
}) => {
  return (
    <Layout activePage={'/diensten/'}>

      <SEO 
        yoast={yoast} 
        path={path}
        image={{ url: acf.banner.image.localFile && acf.banner.image.localFile.childImageSharp.openGraph.src }}
      />

      <HeroDefault fields={acf.banner} />

      {wordpress_id === 131 && (
        <div className="container my-5 pb-lg-3">
          <div className="px-lg-5">
            <div className="px-lg-5 pb-5">
              <Player width="100%" height="100%" controls url="https://player.vimeo.com/progressive_redirect/playback/670238712/rendition/1080p/1080p.mp4?loc=external&signature=24327cbd7856c1b2121ac5e10a764ad2ed9e6c1764c187b2f95c0a85cd390e78" />

            </div>
          </div>
        </div>
      )}

      <div className="container">
        <div className="row my-5">
          <div className="col-lg-6">
            <Image
              src={acf.ingenious.image || Img}
              style={{ objectFit: 'contain' }}
            />
          </div>
          <div className="col-lg-6 position-static">
            <Content content={acf.ingenious.description} />
          </div>
        </div>
      </div>

      <OtherService id={wordpress_id} />
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      ...ServiceDetailFrag
    }
  }
`

export default PageTemplate